import { multinameObj } from '../interfaces/api/I-api-common';
import { ILanguageItem } from '../interfaces/api/I-api-language';

export const mapLanguagesForDept = (deptname: string, languages: ILanguageItem[]) => {
  return [
    {
      language: languages[0].langcode,
      name: deptname,
    },
  ];
};

/**
 * @note 추후 사용자는 부서랑 다른 값을 받을 수 있어서 함수 분리해놈 기존에 mutlnameobj로 받았음
 */
export const mapLanguagesForUser = (info: string, languages: ILanguageItem[]) => {
  return [
    {
      language: languages[0].langcode,
      name: info,
    },
  ];
};
